export const HomeSiteInitialQuestion =[
    "Pricing",
    "Request Demo",
    "Features",
    "Contact Us"
  ]


  export const TBSInitialQuestion =[]